import { RouteRecordRaw } from "vue-router";

export default [
  {
    path: "/spSquareListPage",
    name: "spSquareListPage",
    meta: { title: "专场管理" },
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../../../views/ContentPage/SpSquareAbout/index.vue"
        )
  }
] as Array<RouteRecordRaw>;
